import { toast } from 'react-toastify';
import { ServerMessagesEnums } from './enums/ServerMessagesEnums';

export const setMessage = (msg, tagId, msgId) => async (dispatch) => {
  document.querySelector(tagId).classList.add('alert-danger');
  document.querySelector(msgId).style.color = 'red';
  document.querySelector(msgId).innerHTML = '<h5>' + msg + '</h5>';

  setTimeout(function () {
    document.querySelector(msgId).innerHTML = '';
    document.querySelector(msgId).classList.remove('alert-danger');
    document.querySelector(tagId).classList.remove('alert-danger');
  }, 2000);
};

export const getUpdateValueItem = (list, id) => {
  return list.find((item) => item.id === id);
};

export const handleErrorMessage = (
  error,
  serverValidationMessage,
  clientValidationMessage
) => {
  if (error) {
    return error
      ? error[serverValidationMessage]
      : clientValidationMessage !== ''
      ? clientValidationMessage
      : '';
  }
};

export const textContentPreview = (text, numberOfCharacters) => {
  let description = text;
  if (text.length > numberOfCharacters) {
    description = text.substring(0, numberOfCharacters + 1) + ' ...';
  }
  return description;
};

export const setCoverImage = (image) => {
  return (
    `data:${image?.embeddableAttribute?.mimeType};base64,` +
    image?.embeddableAttribute?.content
  );
};

export const handleServerErrorMessage = (errorMessage) => {
  let errorMessageString = String(errorMessage);
  if (errorMessageString.includes(ServerMessagesEnums.serverNotAvailable)) {
    toast.error(ServerMessagesEnums.toastErrorMessageForServerNotAvailable, {
      toastId: errorMessage,
      icon: false,
      autoClose: 1500,
    });
  } else {
    toast.error(errorMessage, {
      toastId: errorMessage,
      icon: false,
      autoClose: 1500,
    });
  }
};

export const handleServerSuccessMessage = (
  successMessage,
  objectForStoring
) => {
  for (let key in objectForStoring) {
    if (!objectForStoring[key]) {
      return;
    }
  }
  toast.success(successMessage, {
    toastId: successMessage,
    icon: false,
    autoClose: 1500,
  });
};

export const removeUnnecessaryKeys = (objectForStoring) => {
  if (objectForStoring.hasOwnProperty('deleted')) {
  delete objectForStoring['deleted'];
}
if (objectForStoring.hasOwnProperty('authorities')) {
  delete objectForStoring['authorities'];
}
if (objectForStoring.hasOwnProperty('lastLoginDate')) {
  delete objectForStoring['lastLoginDate'];
}
if (objectForStoring.hasOwnProperty('active')) {
  delete objectForStoring['active'];
}
if (objectForStoring.hasOwnProperty('accountNonExpired')) {
  delete objectForStoring['accountNonExpired'];
}
if (objectForStoring.hasOwnProperty('accountNonLocked')) {
  delete objectForStoring['accountNonLocked'];
}
if (objectForStoring.hasOwnProperty('credentialsNonExpired')) {
  delete objectForStoring['credentialsNonExpired'];
}
if (objectForStoring.hasOwnProperty('enabled')) {
  delete objectForStoring['enabled'];
}
}

export const uploadImageAllowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];